export const TITLE_CLICK_AND_COLLECT = 'Click & Collect';
export const TITLE_BUY_IN_STORE = 'Buy in store';

export const getClickAndCollectInfo = (
  isClickAndCollectEnabled: boolean,
  isSelectedDeviceAvailableInStore: boolean,
) => {
  if (!isClickAndCollectEnabled && isSelectedDeviceAvailableInStore) {
    return {
      title: TITLE_BUY_IN_STORE,
    };
  }
  return {
    title: TITLE_CLICK_AND_COLLECT,
  };
};
